module.exports = __webpack_public_path__ + "img/AiSign.21cbc78a.jpg";